import api from "./base-api"

// Templates for the auto-comment posted to the Asana task
// when an order transitions to the READY status (admin functionality).
export const orderCommentApi = api.injectEndpoints({
    endpoints: (build) => ({
        getActiveOrderCommentTemplates: build.query({
            query: () => "order-comment-templates",
            providesTags: ['OrderComments'],
        }),
        getAllOrderCommentTemplates: build.query({
            query: () => "order-comment-templates/all",
            providesTags: ['OrderComments'],
        }),
        createOrderCommentTemplate: build.mutation({
            query: (body) => ({
                url: "order-comment-templates",
                method: "POST",
                body
            }),
            invalidatesTags: ['OrderComments'],
        }),
        updateOrderCommentTemplate: build.mutation({
            query: ({id, ...body}) => ({
                url: `order-comment-templates/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ['OrderComments'],
        }),
        deleteOrderCommentTemplate: build.mutation({
            query: (id) => ({
                url: `order-comment-templates/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['OrderComments'],
        }),
    })
})

export const {
    useGetActiveOrderCommentTemplatesQuery,
    useGetAllOrderCommentTemplatesQuery,
    useCreateOrderCommentTemplateMutation,
    useUpdateOrderCommentTemplateMutation,
    useDeleteOrderCommentTemplateMutation
} = orderCommentApi
